import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "文书标题", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案号", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "法院", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "tr" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "裁判文书内容", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "审理程序", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "tr" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "发布日期", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "裁判日期", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "tr" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "裁决结果", -1)
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "tr" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "被告", -1)
const _hoisted_34 = {
  key: 0,
  class: "value"
}
const _hoisted_35 = {
  key: 1,
  class: "value"
}
const _hoisted_36 = { class: "item" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "原告", -1)
const _hoisted_38 = {
  key: 0,
  class: "value"
}
const _hoisted_39 = {
  key: 1,
  class: "value"
}
const _hoisted_40 = { class: "tr" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "关联企业信息", -1)
const _hoisted_43 = {
  key: 0,
  class: "value"
}
const _hoisted_44 = {
  key: 1,
  class: "value"
}
const _hoisted_45 = { class: "item" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "关联律所信息", -1)
const _hoisted_47 = {
  key: 0,
  class: "value"
}
const _hoisted_48 = {
  key: 1,
  class: "value"
}
const _hoisted_49 = { class: "tr" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "裁决文书格式化内容", -1)
const _hoisted_52 = { class: "value" }
const _hoisted_53 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.caseName || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.d.caseNo || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.d.court || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = true)),
              href: "javascipt:;"
            }, "查看")
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.d.trialRound || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.toDate(_ctx.d.publicdate,"YYYY-MM-DD")), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.toDate(_ctx.d.judgeDate,"YYYY-MM-DD")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.d.judgeResult || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          (_ctx.d.defendantlist && _ctx.d.defendantlist.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.defendantlist, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index && index%2==0?'、':'') + _toDisplayString(index%2==0?item:''), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_35, "-"))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          (_ctx.d.prosecutorlist && _ctx.d.prosecutorlist.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.prosecutorlist, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index && index%2==0?'、':'') + _toDisplayString(index%2==0?item:''), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, "-"))
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          (_ctx.d.relatedComList && _ctx.d.relatedComList.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.relatedComList, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_44, "-"))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          (_ctx.d.relatedLawList && _ctx.d.relatedLawList.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.relatedLawList, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_48, "-"))
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.d.judgeDocInfo || '-'), 1)
        ])
      ])
    ], 512), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.d.caseName,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.d.contentClear
        }, null, 8, _hoisted_53)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}